"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormListManager = void 0;
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const FormListManager = ({ name, component: Component, componentProps, }) => (react_1.default.createElement(formik_1.FieldArray, { name: name, validateOnChange: true }, ({ name, form, remove, push, }) => {
    var _a;
    const values = ((_a = (0, formik_1.getIn)(form.values, name)) !== null && _a !== void 0 ? _a : []);
    const handleAddSome = (newValues) => void form.setFieldValue(name, [...values, ...newValues]);
    return (react_1.default.createElement(Component, Object.assign({ name: name, values: values, isRemoveDisabled: values.filter(({ readonly }) => !readonly).length <= 1, getFieldValueByName: formik_1.getIn, onRemove: remove, onAdd: push, onAddSome: handleAddSome }, componentProps)));
}));
exports.FormListManager = FormListManager;
exports.default = exports.FormListManager;
